import React, { useEffect, useMemo, useState } from "react";
import { Link } from "@quintype/components";
import { shortenUrl } from "../../../../../api/utils";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { getStoryHeadline } from "../../../utils/story";
import StickyBar from "../StickyBar";
import "./progress-bar.m.css";

function ProgressBar({ story, scrollRef, storyIndex, params }) {
  const [shareMenuOpen, setShareMenuOpen] = useState(false);
  const [shortStoryUrl, setShortStoryUrl] = useState(story?.url);
  const [copyPopupOpen, setCopyPopupOpen] = useState(false);
  const headline = getStoryHeadline(story);

  const iconSet = useMemo(
    () => [
      { id: "share-facebook", label: "Facebook", url: `https://www.facebook.com/sharer.php?u=${shortStoryUrl}` },
      {
        id: "share-x",
        label: "X",
        url: `https://twitter.com/intent/tweet?url=${shortStoryUrl}&text=${encodeURIComponent(headline)}`,
      },
      { id: "share-whatsapp", label: "Whatsapp", url: `https://api.whatsapp.com/send?text=${shortStoryUrl}` },
    ],
    [shortStoryUrl]
  );

  const shareIconSet = useMemo(
    () => [
      ...iconSet,
      { id: "share-mail", label: "E-mail", url: `mailto:?subject=${headline}&body=${shortStoryUrl}` },
      {
        id: "share-linkedin",
        label: "Linkedin",
        url: `https://www.linkedin.com/shareArticle?url=${shortStoryUrl}&title=${encodeURIComponent(headline)}`,
      },
    ],
    [iconSet, shortStoryUrl, headline]
  );

  useEffect(() => {
    const fetchShortUrl = async () => {
      try {
        const data = await shortenUrl(story?.url);
        setShortStoryUrl(data?.shortUrl || story?.url);
      } catch (err) {
        console.error("Failed to shorten URL: ", err);
      }
    };

    if (story?.url) {
      fetchShortUrl();
    }
  }, [story?.url]);

  return (
    <>
      <StickyBar
        story={story}
        scrollRef={scrollRef}
        storyIndex={storyIndex}
        params={params}
        shareMenuOpen={shareMenuOpen}
        setShareMenuOpen={setShareMenuOpen}
        iconSet={iconSet}
        setCopyPopupOpen={setCopyPopupOpen}
        shortStoryUrl={shortStoryUrl}
      />
      <div>
        <span styleName="sticky-share-icons">
          {shareMenuOpen && (
            <div styleName="share-menu">
              {shareIconSet.map((item, index) => {
                return (
                  <Link key={index} href={item?.url} target="_blank">
                    <SvgIconHandler
                      className="background-circle"
                      type={item.id}
                      height="32px"
                      width="32px"
                      viewBox="0 0 32 32"
                      iconStyle={{ color: "#596E79" }}
                    />
                    <span>{item?.label}</span>
                  </Link>
                );
              })}
              <div styleName="copy-link-container-2">
                <SvgIconHandler type="share-link" height="32px" width="32px" viewBox="0 0 32 32" />
                <span id="copy-link">Copy link</span>
                {copyPopupOpen && <span styleName="copy-link">Link copied!</span>}
              </div>
            </div>
          )}
        </span>
        {copyPopupOpen && <span styleName="copy-link">Link copied!</span>}
      </div>
    </>
  );
}

export default ProgressBar;
